// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* header {
  height: 31px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.07),
    0 1px 2px 0 rgba(0, 0, 0, 0.05);
  color: #212529;
} */

.nav-area {
  display: flex;
  align-items: center;
  max-width: 100%;
  /* margin: 0 auto; */
  padding: 0x;
  height: 31px;
  border-bottom: 4px solid rgb(36, 101, 75);
  background-color:var(--color-1);
}

.nav-area ol, ul {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.menus {
  display: flex;
  list-style: none;
}

.menu-items {
  position: relative;
  font-size: 12px;
}

.menu-items a {
  display: block;
  font-size: inherit;
  color: inherit;
  text-decoration: none;
}

.menu-items button {
  color: inherit;
  font-size: inherit;
  border: none;
  background-color: transparent;
  cursor: pointer;
  width: 100%;
}

.menu-items a,
.menu-items button {
  text-align: left;
  padding: 0.3rem 1rem;
  font-weight: 700;
}

.menu-items a:hover, .menu-items a.active
.menu-items button:hover, .menu-items button.active {
  background-color: var(--color-3);
}

.arrow::after {
  content: "";
  display: inline-block;
  margin-left: 0.28em;
  vertical-align: 0.09em;
  border-top: 0.42em solid;
  border-right: 0.32em solid transparent;
  border-left: 0.32em solid transparent;
}

.dropdown {
  position: absolute;
  left: 0;
  box-shadow: 0 10px 15px-3px rgba(46, 41, 51, 0.08),
    0 4px 6px-2px rgba(71, 63, 79, 0.16);
  font-size: 0.875rem;
  z-index: 9999;
  min-width: 10rem;
  padding: 0;
  list-style: none;
  background-color: var(--color-1);
  display: none;
  border: 2px solid  var(--color-2);
  border-top: 4px solid  var(--color-2);
}

.dropdown.show {
  display: block;
}

.dropdown.dropdown-submenu {
  position: absolute;
  left: 100%;
  top: -7px;
}

.active-element{
  background-color: var(--color-4);
}

.single-line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.border-1{
  border: 1px solid black;
}

.scroll-container-style {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: absolute;
  overflow: hidden;
  overflow-y: auto
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;;;;GAKG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP;wCACsC;EACtC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,MAAM;EACN,SAAS;EACT,QAAQ;EACR,OAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB;AACF","sourcesContent":["*{\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* header {\n  height: 31px;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.07),\n    0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  color: #212529;\n} */\n\n.nav-area {\n  display: flex;\n  align-items: center;\n  max-width: 100%;\n  /* margin: 0 auto; */\n  padding: 0x;\n  height: 31px;\n  border-bottom: 4px solid rgb(36, 101, 75);\n  background-color:var(--color-1);\n}\n\n.nav-area ol, ul {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.menus {\n  display: flex;\n  list-style: none;\n}\n\n.menu-items {\n  position: relative;\n  font-size: 12px;\n}\n\n.menu-items a {\n  display: block;\n  font-size: inherit;\n  color: inherit;\n  text-decoration: none;\n}\n\n.menu-items button {\n  color: inherit;\n  font-size: inherit;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  width: 100%;\n}\n\n.menu-items a,\n.menu-items button {\n  text-align: left;\n  padding: 0.3rem 1rem;\n  font-weight: 700;\n}\n\n.menu-items a:hover, .menu-items a.active\n.menu-items button:hover, .menu-items button.active {\n  background-color: var(--color-3);\n}\n\n.arrow::after {\n  content: \"\";\n  display: inline-block;\n  margin-left: 0.28em;\n  vertical-align: 0.09em;\n  border-top: 0.42em solid;\n  border-right: 0.32em solid transparent;\n  border-left: 0.32em solid transparent;\n}\n\n.dropdown {\n  position: absolute;\n  left: 0;\n  box-shadow: 0 10px 15px-3px rgba(46, 41, 51, 0.08),\n    0 4px 6px-2px rgba(71, 63, 79, 0.16);\n  font-size: 0.875rem;\n  z-index: 9999;\n  min-width: 10rem;\n  padding: 0;\n  list-style: none;\n  background-color: var(--color-1);\n  display: none;\n  border: 2px solid  var(--color-2);\n  border-top: 4px solid  var(--color-2);\n}\n\n.dropdown.show {\n  display: block;\n}\n\n.dropdown.dropdown-submenu {\n  position: absolute;\n  left: 100%;\n  top: -7px;\n}\n\n.active-element{\n  background-color: var(--color-4);\n}\n\n.single-line {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.border-1{\n  border: 1px solid black;\n}\n\n.scroll-container-style {\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  position: absolute;\n  overflow: hidden;\n  overflow-y: auto\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
